import * as React from 'react';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import { Box } from '@mui/system';

export default function RadioYN({ label, value, onChange, data, sx, valueKey }) {
  return (
    <Box sx={sx}>
      <FormControl fullWidth>
        <FormLabel id="demo-row-radio-buttons-group-label">{label}</FormLabel>
        <RadioGroup
          row
          aria-labelledby="demo-row-radio-buttons-group-label"
          name="row-radio-buttons-group"
          value={value}
          onChange={(i, v) => onChange(v)}
        >
          {data.map((e, i) => (
            <FormControlLabel key={i} value={valueKey ? e?.[valueKey] : e.value} control={<Radio />} label={e.label} />
          ))}
        </RadioGroup>
      </FormControl>
    </Box>
  );
}
